/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import {Component} from 'react';
import ReactDOM from 'react-dom';

class GlobalPortal extends Component {

    componentWillUnmount() {
        if (this.defaultNode) {
            document.body.removeChild(this.defaultNode);
        }
        this.defaultNode = null;
    }

    render() {
        if (!(!!(
            typeof window !== 'undefined' &&
            window.document &&
            window.document.createElement
        ))) {
            return null;
        }
        if (!this.props.node && !this.defaultNode) {
            this.defaultNode = document.createElement('div');
            document.body.appendChild(this.defaultNode);
        }
        return ReactDOM.createPortal(
            this.props.children,
            this.props.node || this.defaultNode
        );
    }
}

GlobalPortal.propTypes = {};

export default GlobalPortal;